<div class="circle " >
    <span *ngIf="micOn" nz-icon nzType="audio" nzTheme="fill" (click)="startListening()" [nzTheme]="'twotone'" [nzTwotoneColor]="'#4682A9'"></span>
    <span *ngIf="!micOn"   nz-icon nzType="audio" nzTheme="fill" (click)="stopListening()" [nzTheme]="'twotone'" [nzTwotoneColor]="'#52c41a'"></span>
   <div class="pulse-ring" *ngIf="!micOn"></div>
</div>

<p style=" margin-left:14px;margin-top:10px;"> <span *ngIf="!micOn" style="font-size: 12px;" > Listening...</span>  </p>
 